<script lang="ts">
  // Marks a figure where the rider was the highest of their group.
  export let size = 28
  export let color = 'var(--accent)'
</script>

<svg class="xr-shield" width={size} height={size} viewBox="0 0 24 24" aria-label="Highest of the group">
  <path d="M12 2.2c2.3 1.7 5 2.7 8 2.9v6.6c0 5-3.4 8.6-8 10.1-4.6-1.5-8-5.1-8-10.1V5.1c3-.2 5.7-1.2 8-2.9Z" style="fill: {color}" />
  <path d="m8.4 12.2 2.4 2.4 4.8-5" fill="none" stroke="#0b1114" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" />
</svg>

<style>
  .xr-shield {
    display: inline-block;
    flex: none;
  }
</style>
